import { createSlice } from '@reduxjs/toolkit';

export const menuStateSlice = createSlice({
  name: 'menuState',
  initialState: {
    open: false,
  },
  reducers: {
    toggleMenu: (state, action) => {
      state.open = !action.payload;
    },
  },
});

export const { toggleMenu } = menuStateSlice.actions;
export default menuStateSlice.reducer;